import { createApp } from 'vue'
import i18nPlugin, { i18n, loadTranslations } from '../../i18n'
import GepsAwbForm from '../../components/shipment-management/geps-awb-form.vue'

$.onmount('[data-vue=geps-awb-form]', async function () {
  const initialData = JSON.parse(this.attributes['data-initial-data'].value)

  const app = createApp(GepsAwbForm, { initialData })

  app.use(i18nPlugin)

  await loadTranslations(i18n)

  app.mount(this)
})
